module.exports = __webpack_public_path__ + "static/scen-10-19f43cc82e577f22b2419e716ff0d1e2.svg";